module.exports = __webpack_public_path__ + "img/ico_tit_bulk.a330a13.svg";